/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */
import React from "react";
import { Link } from "react-router-dom";
import { CarouselImage } from "cms/components/hero-carousel/carousel-image";
import { RichTextSimple } from "@simplicitycms/simplicity-richtext";
import { ReactComponent as LeftArrow } from "cms/assets/icons/arrow-left.svg";
import { ReactComponent as RightArrow } from "cms/assets/icons/arrow-right.svg";
import { ReactComponent as LogoOverlay } from "cms/assets/images/kitimat-hero-logo.svg";

const HeroCarouselSlide = (props) => {

    const slides = props?.slides;
    const images = props?.images;
    const index = props?.index;
    const total = props?.total;
    const moveIndex = props?.moveIndex;
    const contentPosition = props?.contentPosition;

    const slide = slides[index];
    const slideImage = slide?.image;
    const { title, description, link } = slide || {};
    const { text, url: link_url } = link || {};
    const image = Array.isArray(images) && images[index];
    let settings;
    if (slideImage) {
        settings = slideImage?.settings;
    }
    const previous = () => {
        moveIndex(-1);
    };
    const next = () => {
        moveIndex(1);
    };

    const showControls = slides?.length > 1;

    return (
        <div className={`carousel-slide ${contentPosition}`}>

            <div className="carousel-image-wrapper">
                <CarouselImage
                    image={image}
                    slide={slide}
                    settings={settings}
                    isHomepage={false}
                />
            </div>

            <div className="carousel-content">
                <div className="carousel-text-content">

                    <h1>{title}</h1>

                    <RichTextSimple
                        richtext={description}
                        className='carousel-slide-description'
                    />

                    <Link to={link_url} className='carousel-slide-link'>
                        {text}
                    </Link>
                </div>

                {showControls &&
                    <div className="controls">
                        <button aria-label="Previous" onClick={previous}>
                            <LeftArrow alt="left arrow" />
                        </button>

                        <span>{`${index + 1}/${total}`}</span>

                        <button aria-label="Next" onClick={next}>
                            <RightArrow alt="right arrow" />
                        </button>
                    </div>
                }

                <LogoOverlay className="hero-logo-overlay" alt="kitimat logo" />
            </div>

        </div>
    );
};
export { HeroCarouselSlide };
